export { StarRating } from './StarRating'
export type { StarRatingProps } from './StarRating'
